import React from 'react';

const NaviIconWithText = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="40"
      viewBox="0 0 108 40"
      fill="none"
    >
      <path
        d="M14.4165 16.1739C13.8472 15.6296 13.0885 15.3262 12.3006 15.3262H1V33.8403H7.26419V21.312H13.5284V31.7523C13.5284 32.9049 14.4638 33.8403 15.6165 33.8403H19.7926V22.6219C19.7926 21.7852 19.4501 20.9862 18.846 20.4071L14.4165 16.1739Z"
        fill="#22D081"
      />
      <path d="M13.5288 6V11.9858H22.8555V21.3125H28.8413V6H13.5288Z" fill="#22D081" />
      <path
        d="M56.2905 16.0041C55.8256 15.5684 55.2131 15.3262 54.5769 15.3262H44.1533V33.8403H48.6079V19.5023H55.5681V32.1699C55.5681 33.0928 56.3156 33.8403 57.2385 33.8403H60.0226V20.5881C60.0226 19.8949 59.7359 19.2336 59.2305 18.7603L56.2905 16.0041V16.0041Z"
        fill="#3C0050"
      />
      <path d="M106.1 15.3262H101.645V33.8403H106.1V15.3262Z" fill="#3C0050" />
      <path
        d="M89.9516 31.8915L85.7754 15.3262H81.0425L86.1193 32.6404C86.3281 33.3517 86.9809 33.8403 87.7229 33.8403H92.1816C92.9236 33.8403 93.5764 33.3517 93.7852 32.6404L98.862 15.3262H94.1291L89.9529 31.8915H89.9516Z"
        fill="#3C0050"
      />
      <path
        d="M75.5122 16.0598C75.0417 15.5893 74.4055 15.3262 73.7401 15.3262H65.3127V17.8318C65.3127 18.7548 66.0602 19.5023 66.9832 19.5023H74.7786V22.5648H67.9673C67.3354 22.5648 66.7256 22.8042 66.2621 23.2344L63.8413 25.4825C63.3597 25.9308 63.0854 26.5586 63.0854 27.217V29.0531C63.0854 29.7102 63.3583 30.338 63.8399 30.7848L66.4013 33.1694C66.8648 33.6009 67.4746 33.8417 68.1093 33.8417H78.9561V20.5422C78.9561 19.8781 78.6916 19.2406 78.2225 18.7701L75.5136 16.0612L75.5122 16.0598ZM74.7786 30.0818H67.2616V25.9057H74.7786V30.0818Z"
        fill="#3C0050"
      />
    </svg>
  );
};

export default NaviIconWithText;
